export default {
  close: {
    en: 'Close',
  },
  remove: {
    en: 'Remove',
  },
}
